import { Injectable } from '@angular/core';

export interface PendingLeadTrackingVerification {
  nationalID: string;
  mobileNumber: string;
  otpCountdownSeconds: number;
}

@Injectable({ providedIn: 'root' })
export class LeadTrackingState {
  private static readonly REQUEST_ID_STORAGE_KEY = 'finora.leadRequestId';
  private pendingVerification: PendingLeadTrackingVerification | null = null;
  private requestId =
    this.getBrowserSessionStorage()?.getItem(LeadTrackingState.REQUEST_ID_STORAGE_KEY) ?? '';

  setPendingVerification(value: PendingLeadTrackingVerification): void {
    this.pendingVerification = value;
  }

  getPendingVerification(): PendingLeadTrackingVerification | null {
    return this.pendingVerification;
  }

  clearPendingVerification(): void {
    this.pendingVerification = null;
  }

  setRequestId(requestId: string): void {
    this.requestId = requestId;
    this.getBrowserSessionStorage()?.setItem(LeadTrackingState.REQUEST_ID_STORAGE_KEY, requestId);
  }

  getRequestId(): string {
    return this.requestId;
  }

  clearRequestId(): void {
    this.requestId = '';
    this.getBrowserSessionStorage()?.removeItem(LeadTrackingState.REQUEST_ID_STORAGE_KEY);
  }

  private getBrowserSessionStorage(): Storage | null {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  }
}
